module.exports = __webpack_public_path__ + "static/media/Redacteur.dd30ab9b.PNG";